module.exports = __webpack_public_path__ + "img/CHEDRAUI.f0454190.png";